import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Header from "./components/Header/Header";
import Class from "./components/Class/Class";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Class></Class>
    </div>
  );
}

export default App;
